export const ORGANIZATION_COLUMNS = [
  { id: 'select', label: '', alwaysVisible: true, defaultVisible: true },
  { id: 'organization', label: 'Organization', alwaysVisible: true, defaultVisible: true },
  { id: 'contacts_count', label: '# of Contacts', alwaysVisible: false, defaultVisible: true },
  { id: 'city', label: 'City', alwaysVisible: false, defaultVisible: true },
  { id: 'state', label: 'State', alwaysVisible: false, defaultVisible: true },
  { id: 'created_at', label: 'Date Added', alwaysVisible: false, defaultVisible: true },
  { id: 'location', label: 'Location', alwaysVisible: false, defaultVisible: false },
  { id: 'country', label: 'Country', alwaysVisible: false, defaultVisible: false },
  { id: 'email', label: 'Email', alwaysVisible: false, defaultVisible: false },
  { id: 'phone', label: 'Phone', alwaysVisible: false, defaultVisible: false },
  { id: 'website', label: 'Website', alwaysVisible: false, defaultVisible: false },
  { id: 'contact', label: 'Contact', alwaysVisible: false, defaultVisible: false },
];

export const SORT_OPTIONS = [
  { value: 'name asc', label: 'Name (A-Z)' },
  { value: 'name desc', label: 'Name (Z-A)' },
  { value: 'created_at desc', label: 'Newest First' },
  { value: 'created_at asc', label: 'Oldest First' },
  { value: 'city asc', label: 'City (A-Z)' },
  { value: 'state asc', label: 'State (A-Z)' },
];

export const getDefaultVisibleColumns = () =>
  ORGANIZATION_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  ORGANIZATION_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
